import { defineMessages } from "react-intl";

import {
	vaccinationTypeMessages,
	validator
} from "lib/build/forms/ktx/transplantation-screening/medical-history/covid/covidVaccination";

import { FieldsetData } from "src/features/forms";
import { genericErrorMessages } from "src/messages/generic";
import { LeafNode } from "src/modules/shared/form-explorer";

const messages = defineMessages({
	covidVaccination: {
		id: "ktx.form.covid_vaccination.title",
		defaultMessage: "COVID vakcináció"
	},
	vaccinationType: {
		id: "ktx.form.covid_vaccination.type",
		defaultMessage: "Oltás típusa"
	}
});

const fieldset: FieldsetData = {
	rows: [
		{
			columns: [
				{
					width: 12,
					field: {
						type: "field",
						path: ["vaccinationType"],
						label: messages.vaccinationType,
						errorMessages: genericErrorMessages,
						input: {
							type: "select",
							props: {
								labels: vaccinationTypeMessages
							}
						}
					}
				}
			]
		}
	]
};

export const node: LeafNode = {
	id: "ktx_covidVaccination",
	value: {
		schemaId: "covidVaccination",
		title: messages.covidVaccination,
		validator,
		fieldset,
		applyCurrentDate: false
	}
};
